import { AcademicLevel, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired, Section, Specialites } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Consentement,
  cursus: Yup.string().required(`Vous devez choisir un cursus d'intérêt`),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Section,
    Speciality__c: Yup.string().when('Undecided__c', {
      is: (undecided) => undecided !== true,
      then: (schema) => schema.required(`Vous devez choisir un programme d'intérêt`),
      otherwise: (schema) => schema.notRequired()
    })
  }),
  ...Specialites
})

export default schema
